import request from '@core/services/request';

export const dartAPI = {
	sync: (fimenu: any) => request.post(`/Dart/Sync`, fimenu),
	checkIfDealExistsOrLockedInCDK: (dealNumber: any, storeCode: any) => request.get(`/Dart/CheckIfDealExistsOrLockedInCDK/${storeCode}/${dealNumber}`),
	getDealPricing: (fimenu: any) => request.post(`/Dart/GetDealPricing`, fimenu),
	updateProducts: (fimenu: any) => request.post(`/Dart/UpdateProducts`, fimenu),
	createNewCDKDeal: (storeCode: any, financeType: any) => request.post(`/Dart/CreateNewCDKDeal`, { storeCode, financeType }),
	dartTest: (dealId: string) => request.post(`/Dart/DartTest/${dealId}`),
};
